import { Divider, Paper, Tab, Tabs } from "@material-ui/core/";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import SwipeableViews from "react-swipeable-views";
import { compose } from "recompose";
import { FeedbackTab, Page } from "../../../shared/components";
import { setTabSelecionada } from "../../../shared/redux/UIActions";
import UsuarioService from "../../usuario/usuarioService";
import { UsuarioAuth0VinculoTabContainer } from "../../usuarioAuth0";
import { UsuarioClienteVinculoTabContainer } from "../../usuarioClienteVinculo";
import { UsuarioFazendaVinculoTabContainer } from "../../usuarioFazendaVinculo";
import { UsuarioRetiroVinculoTabContainer } from "../../usuarioRetiroVinculo/";
import { obtemTabPeloHash, TABS_PATH_HASH } from "../vinculosUtils";

export class VinculoPage extends PureComponent {
  constructor(props) {
    super(props);
    this.mudaTab(null, 0);
    this.state = {
      usuarioSelecionado: this.props.location.usuario || null,
    };
  }

  async componentDidMount() {
    if (this.state.usuarioSelecionado) {
      return;
    }

    const { IdUsuario } = this.props.match.params;
    if (IdUsuario == null) {
      return;
    }

    try {
      const data = await UsuarioService.buscaUsuario(IdUsuario);
      const usuario = data && data.data && data.data[0];

      if (usuario) {
        this.setState({
          usuarioSelecionado: {
            IdUsuario: usuario.idUsuario,
            Nome: usuario.nome,
            Email: usuario.email,
            Login: usuario.login,
          },
        });
      }
    } catch (error) {
      console.error(
        "Falha ao recuperar usuário após atualização da página",
        error,
      );
    }
  }

  mudaTab = (event, value) => {
    const tab = this.obtemTabPeloIndex(value);
    this.props.history.push(tab.path);
    setTimeout(() => {
      this.props.setTabSelecionada(tab.path);
    }, 500);
  };

  mudaTabIndex = (index) => {
    this.setState({ value: index });
  };

  obtemTabPeloIndex = (index) => {
    return TABS_PATH_HASH[index];
  };

  mapTabs = (pathName) => {
    return [...TABS_PATH_HASH].map((tab, index) => {
      return (
        <Tab
          label={tab.tituloTab}
          key={`tab-${index}`}
          disabled={tab.desabilitada}
        />
      );
    });
  };

  render() {
    const { usuarioSelecionado } = this.state;
    const { classes, theme, location } = this.props;
    const tituloComNome =
      usuarioSelecionado && usuarioSelecionado.Nome
        ? usuarioSelecionado.Nome
        : "";
    const pathName = location.pathname;
    const tabSelecionada = obtemTabPeloHash(location.hash);
    return (
      <Page
        titulo={`Vincular usuário ${tituloComNome}`}
        exibirConteudo
        conteudo={
          <Paper className={classes.root}>
            <Tabs
              value={tabSelecionada.index}
              onChange={this.mudaTab}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
            >
              {this.mapTabs(pathName)}
            </Tabs>
            <Divider />
            {usuarioSelecionado ? (
              <SwipeableViews
                id="SwipeableViews"
                axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                index={tabSelecionada.index}
                onChangeIndex={this.mudaTabIndex}
              >
                <UsuarioClienteVinculoTabContainer
                  usuario={usuarioSelecionado}
                />
                <UsuarioFazendaVinculoTabContainer
                  usuario={usuarioSelecionado}
                />
                <UsuarioRetiroVinculoTabContainer
                  usuario={usuarioSelecionado}
                />
                <UsuarioAuth0VinculoTabContainer usuario={usuarioSelecionado} />
              </SwipeableViews>
            ) : (
              <FeedbackTab mensagem="Selecione um usuário" />
            )}
          </Paper>
        }
      />
    );
  }
}

const mapDispatchToProps = {
  setTabSelecionada: setTabSelecionada,
};
VinculoPage.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

const styles = (theme) => ({
  root: {
    backgroundColor: "#fff",
    width: "100%",
  },
});

export default compose(
  withRouter,
  withStyles(styles, { withTheme: true }),
  connect(null, mapDispatchToProps),
)(VinculoPage);
